/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner } from './get-cards-transactions-with-purchase-application-unlinked200-response-inner-merged-card-transaction-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
 */
export interface GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'transactionType': GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner>}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'transactionRecordList': Array<GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransaction
     */
    'isCleared': boolean;
}

export const GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionTypeEnum = typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionTypeEnum[keyof typeof GetCardsTransactionsWithPurchaseApplicationUnlinked200ResponseInnerMergedCardTransactionTransactionTypeEnum];


